export const NO_AIRPORT_CODE = '999';
